import { useQuery } from '@hooks/reactQuery';

import { getNodeTypes } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';

import { ICCOptionsProps } from '@interfaces/cmModule/configurationComparison';
import { TCMNodeVendorTechnology } from '@interfaces/cmModule/dto/cmModuleDTO';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CC_NODE_TYPES } from '@constants/queryKeys';

export const useQueryNodeTypes = ({
	technology,
	vendor,
}: TCMNodeVendorTechnology) => {
	const {
		data: nodeTypesOptions,
		isFetching: isFetchingNodeTypesOptions,
		isLoading: isLoadingNodeTypesOptions,
	} = useQuery({
		queryKey: [
			CC_NODE_TYPES, {
				technology,
				vendor,
			},
		],
		queryFn: extractQueryParams(getNodeTypes),
		select: (options: Array<ICCOptionsProps>) => {
			return options
				.filter(option => option.isAvailable)
				.map(option => ({
					label: option.type.title,
					value: option.type.name,
				}));
		},
		enabled: [!!technology, !!vendor, vendor !== EVendorsValues.mavenir],
		...refetchOptions,

	});

	return {
		nodeTypesOptions: nodeTypesOptions || [],
		isLoadingNodeTypesOptions: isLoadingNodeTypesOptions && isFetchingNodeTypesOptions,
	};
};
